import React from "react";
import { FormFieldView } from "./view";
import { styles } from "./styles";

export const FormField = props => <FormFieldView {...props} styles={styles} />;
